import React from 'react';
import { useRouteMatch, useHistory } from 'react-router-dom';
import IconButton from '@material-ui/core/IconButton';
import SettingsIcon from '@material-ui/icons/Settings';
import PropTypes from 'prop-types';

import { useTheme } from '@material-ui/core';

export default function EditRecordButton(props) {
  let history = useHistory();
  const match = useRouteMatch();
  const theme = useTheme();
  return (
    <IconButton
      size="small"
      // Icon-only, so without this every row's control is announced the same.
      // The caller names the row it belongs to ("Modifica <email>").
      aria-label={props.ariaLabel}
      disabled={props.disabled}
      style={{
        color: props.disabled
          ? theme.palette.disabled.main
          : theme.palette.primary.main,
      }}
      onClick={() => {
        if (props.path !== undefined && props.path !== null) {
          history.push(props.path);
        } else {
          history.push(`${match.url}/${props.recordId}`);
        }
      }}
    >
      <SettingsIcon />
    </IconButton>
  );
}

EditRecordButton.propTypes = {
  recordId: PropTypes.number.isRequired,
  disabled: PropTypes.bool.isRequired,
  path: PropTypes.string,
  ariaLabel: PropTypes.string,
};
